module.exports = __webpack_public_path__ + "img/icon_links.45aaf1af.png";